
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { BrandModel } from './Entities.GormCrm.Brand';
import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderProductPlanDiscontinuationModel } from './Entities.GormCrm.OrderProductPlanDiscontinuation';
import { PlanReplacementNewPlanModel } from './Entities.GormCrm.PlanReplacementNewPlan';
import { PlanReplacementOldPlanModel } from './Entities.GormCrm.PlanReplacementOldPlan';
import { ProductPlanTagModel } from './Entities.GormCrm.ProductPlanTag';
import { SettlementProductPlanModel } from './Entities.GormCrm.SettlementProductPlan';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { TransferPlanModel } from './Entities.GormCrm.TransferPlan';
import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanModel extends Model<ProductPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'parentId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'productName', type: 'string' },
		{ name: 'productIdentification', type: 'string' },
		{ name: 'terminationDate', type: 'Date' },
		{ name: 'terminationReasonId', type: 'string' },
		{ name: 'autoRenewalDate', type: 'Date' },
		{ name: 'nextPeriod', type: 'number' },
		{ name: 'annualValueForRenewal', type: 'number' },
		{ name: 'unitPrice', type: 'number' },
		{ name: 'units', type: 'number' },
		{ name: 'paymentScheme', type: 'number' },
		{ name: 'autoRenewable', type: 'boolean' },
		{ name: 'deliveryDate', type: 'Date' },
		{ name: 'terminationNoticePeriod', type: 'number' },
		{ name: 'restrictEndDate', type: 'Date' },
		{ name: 'brandId', type: 'string' },
		{ name: 'brand', type: 'BrandModel', isHidden: true, isObject: true, new: () => { return new BrandModel }, properties: () => { return BrandModel.classProperties } },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'inverseParent', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'orderProductPlanDiscontinuations', type: 'OrderProductPlanDiscontinuationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderProductPlanDiscontinuationModel }, properties: () => { return OrderProductPlanDiscontinuationModel.classProperties } },
		{ name: 'parent', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'planReplacementNewPlans', type: 'PlanReplacementNewPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementNewPlanModel }, properties: () => { return PlanReplacementNewPlanModel.classProperties } },
		{ name: 'planReplacementOldPlans', type: 'PlanReplacementOldPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementOldPlanModel }, properties: () => { return PlanReplacementOldPlanModel.classProperties } },
		{ name: 'productPlanTags', type: 'ProductPlanTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanTagModel }, properties: () => { return ProductPlanTagModel.classProperties } },
		{ name: 'settlementProductPlans', type: 'SettlementProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementProductPlanModel }, properties: () => { return SettlementProductPlanModel.classProperties } },
		{ name: 'terminationReason', type: 'ReasonModel', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'transferPlans', type: 'TransferPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferPlanModel }, properties: () => { return TransferPlanModel.classProperties } },
		{ name: 'orderLines', type: 'OrderLineModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'taskflows', type: 'TaskflowModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public parentId?: string;
	public companyId?: string;
	public productName: string;
	public productIdentification: string;
	public terminationDate?: Date;
	public terminationReasonId?: string;
	public autoRenewalDate?: Date;
	public nextPeriod?: number;
	public annualValueForRenewal: number;
	public unitPrice?: number;
	public units?: number;
	public paymentScheme?: number;
	public autoRenewable: boolean;
	public deliveryDate?: Date;
	public terminationNoticePeriod: number;
	public restrictEndDate?: Date;
	public brandId?: string;
	public brand?: BrandModel;
	public company?: CompanyModel;
	public inverseParent: ProductPlanModel[];
	public orderProductPlanDiscontinuations: OrderProductPlanDiscontinuationModel[];
	public parent?: ProductPlanModel;
	public planReplacementNewPlans: PlanReplacementNewPlanModel[];
	public planReplacementOldPlans: PlanReplacementOldPlanModel[];
	public productPlanTags: ProductPlanTagModel[];
	public settlementProductPlans: SettlementProductPlanModel[];
	public terminationReason?: ReasonModel;
	public transferPlans: TransferPlanModel[];
	public orderLines: OrderLineModel[];
	public taskflows: TaskflowModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.parentId = undefined;
		this.companyId = undefined;
		this.productName = '';
		this.productIdentification = '';
		this.terminationDate = undefined;
		this.terminationReasonId = undefined;
		this.autoRenewalDate = undefined;
		this.nextPeriod = undefined;
		this.annualValueForRenewal = 0;
		this.unitPrice = undefined;
		this.units = undefined;
		this.paymentScheme = undefined;
		this.autoRenewable = false;
		this.deliveryDate = undefined;
		this.terminationNoticePeriod = 0;
		this.restrictEndDate = undefined;
		this.brandId = undefined;
		this.brand = undefined;
		this.company = undefined;
		this.inverseParent = [];
		this.orderProductPlanDiscontinuations = [];
		this.parent = undefined;
		this.planReplacementNewPlans = [];
		this.planReplacementOldPlans = [];
		this.productPlanTags = [];
		this.settlementProductPlans = [];
		this.terminationReason = undefined;
		this.transferPlans = [];
		this.orderLines = [];
		this.taskflows = [];
		
	}
	getProperties(){
		return ProductPlanModel.classProperties;
	}
}

